module.exports = __webpack_public_path__ + "img/61.a0b0d6c5.svg";